export default __webpack_public_path__ + "static/sustainability-5-38bdeeed120ed414cc85259ad70ef2c3.jpg";